import { render } from "./rx-harmony-logo.svg?vue&type=template&id=2b3ad4eb"
import script from "./rx-harmony-logo.svg?vue&type=script&lang=js"
export * from "./rx-harmony-logo.svg?vue&type=script&lang=js"

import "./rx-harmony-logo.svg?vue&type=style&index=0&id=2b3ad4eb&lang=css"

import exportComponent from "/codebuild/output/src539/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__